/**
 * PM message translation. The panel opens under the bubble, outside
 * .msg_body, so the live-edit swap of .msg-body-text never touches it.
 */

import { focusFirstRendered } from '../../modules/focus-fallback.js';
import { closeTranslation, openPanel, toggleTranslation } from '../../modules/translation-panel.js';

function messageText(msgId) {
  var body = document.querySelector('#msg_' + msgId + ' .msg-body-text');
  return body ? (body.innerText || body.textContent || '').trim() : '';
}

function bubbleWrap(msgId) {
  return document.querySelector('#msg_' + msgId + ' .pm-msg-bubble-wrap');
}

/** A message from another sender whose body has text. */
window.isMessageTranslatable = function (msgId) {
  var msg = document.getElementById('msg_' + msgId);
  if (!msg || String(msg.getAttribute('data-sender-id') || '') === window.pmCurrentUserId()) {
    return false;
  }
  return messageText(msgId) !== '';
};

/** The message's options button. Phones hide it until a tap on the bubble shows the message's actions. */
function actionsToggle(wrap) {
  return wrap && wrap.closest('[id^="msg_"]')?.querySelector('.msg-actions-toggle');
}

// The closed menu or sheet hid the item that held focus.
window.translateMessage = function (msgId) {
  window.closeMessageActionMenus();
  var anchor = bubbleWrap(msgId);
  if (anchor) {
    toggleTranslation(anchor, messageText(msgId), { className: 'max-w-[85vw] sm:max-w-[80%]' });
    focusFirstRendered(actionsToggle(anchor), openPanel(anchor), anchor);
  }
};

document.addEventListener('translation-closed', function (event) {
  var wrap = event.target instanceof Element ? event.target.closest('.pm-msg-bubble-wrap') : null;
  if (wrap && event.detail?.hadFocus) {
    // The tap handler of message-actions.js hides the phone toolbar later in the same click.
    setTimeout(function () {
      focusFirstRendered(actionsToggle(wrap), wrap);
    }, 0);
  }
});

/** Drop an open translation once the message text changes. */
window.closeMessageTranslation = function (msgId) {
  closeTranslation(bubbleWrap(msgId));
};
